import React from 'react'
import { isAgentLogin, isCarrierLogin } from 'tools/auth'
import { REPORT_KEYS } from 'constants/reporting'
import ConsoleEmbed from 'components/ConsoleEmbed'
import { useEnsureInvitingCompanyId } from 'hooks/useEnsureInvitingCompanyId'

/**
 * FleetFile > Risk Score. The whole tab is one tc-console embed
 * (`/reporting/embed?type=fleetfile`), gated by the
 * `reporting.fleetfile.use-console` flag inside ConsoleEmbed.
 *
 * Portfolio-wide by design: no `carrierId`, so the console resolves every CEA
 * of the token's own company (same posture as the Risk Deciles tab). The page
 * is only routed for insurer logins, but the agent/carrier branch below is kept
 * for parity with the other embeds — an agent or carrier session must send
 * invitingCompanyId or the embed has no insurer to scope to.
 */
const RiskScoreDashboard: React.FC = () => {
  const ensuredInvitingCompanyId = useEnsureInvitingCompanyId()

  const isAgentOrCarrier = isCarrierLogin() || isAgentLogin()
  const invitingCompanyId = isAgentOrCarrier
    ? ensuredInvitingCompanyId
    : undefined

  return (
    <ConsoleEmbed
      reportKey={REPORT_KEYS.FLEETFILE}
      invitingCompanyId={invitingCompanyId}
      fullHeight
      testId="fleetfile-risk-score-iframe"
    />
  )
}

export default RiskScoreDashboard
